import IChangePassword from "../../models/Form/IChangePassword";

export const initialState: IChangePassword = {
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
}